import React, { useState, useEffect } from "react";
import MarkdownWrapper from "../MarkdownWrapper";
import api from "../../services/api";

const contactCache = {};

const MentionChip = ({ phoneNumber }) => {
  const [displayName, setDisplayName] = useState(null);

  useEffect(() => {
    if (contactCache[phoneNumber] !== undefined) {
      setDisplayName(contactCache[phoneNumber]);
      return;
    }
    api
      .get("/contacts/", { params: { searchParam: phoneNumber, pageSize: 5 } })
      .then(({ data }) => {
        const match = data.contacts?.find((c) => c.number === phoneNumber);
        const name = match?.name || phoneNumber;
        contactCache[phoneNumber] = name;
        setDisplayName(name);
      })
      .catch(() => {
        contactCache[phoneNumber] = phoneNumber;
        setDisplayName(phoneNumber);
      });
  }, [phoneNumber]);

  return (
    <span
      style={{
        color: "#429084",
        fontWeight: 600,
        backgroundColor: "rgba(66,144,132,0.12)",
        borderRadius: 4,
        padding: "0 3px",
      }}
    >
      @{displayName ?? phoneNumber}
    </span>
  );
};

const MENTION_RE = /@(\d+)/g;

const MessageText = ({ children }) => {
  if (!children) return null;

  const parts = [];
  let lastIndex = 0;
  let match;
  MENTION_RE.lastIndex = 0;

  while ((match = MENTION_RE.exec(children)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", content: children.slice(lastIndex, match.index) });
    }
    parts.push({ type: "mention", phoneNumber: match[1] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < children.length) {
    parts.push({ type: "text", content: children.slice(lastIndex) });
  }

  if (parts.length === 0 || parts.every((p) => p.type === "text")) {
    return <MarkdownWrapper>{children}</MarkdownWrapper>;
  }

  return (
    <>
      {parts.map((part, i) =>
        part.type === "mention" ? (
          <MentionChip key={i} phoneNumber={part.phoneNumber} />
        ) : (
          <MarkdownWrapper key={i}>{part.content}</MarkdownWrapper>
        )
      )}
    </>
  );
};

export default MessageText;
